<div class="budget-helper-container">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Asistente de Presupuesto</mat-card-title>
        <mat-card-subtitle>Administra tu presupuesto mensual</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <section>
          <h2>Agregar Gasto</h2>
          <form (ngSubmit)="addBudgetItem()">
            <mat-form-field>
              <mat-label>Nombre del Gasto</mat-label>
              <input matInput [(ngModel)]="newBudgetItem.name" name="name" required>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Categoría</mat-label>
              <input matInput [(ngModel)]="newBudgetItem.category" name="category" required>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Monto</mat-label>
              <input matInput type="number" [(ngModel)]="newBudgetItem.amount" name="amount" required>
            </mat-form-field>
            <button mat-raised-button color="primary" type="submit">Agregar</button>
          </form>
        </section>
  
        <section>
          <h2>Supermercado</h2>
          <div *ngFor="let item of supermarketItems">
            <mat-card class="supermarket-item">
              <mat-card-content>
                <p>{{ item.name }} - {{ item.category }} - {{ item.amount | currency }}</p>
                <button mat-icon-button color="primary" (click)="addToCart(item)">
                  <mat-icon>add_shopping_cart</mat-icon>
                </button>
              </mat-card-content>
            </mat-card>
          </div>
        </section>
  
        <section>
          <h2>Carrito</h2>
          <div *ngFor="let item of cart; let i = index">
            <mat-card class="cart-item">
              <mat-card-content>
                <p>{{ item.name }} - {{ item.category }} - {{ item.amount | currency }}</p>
                <button mat-icon-button color="warn" (click)="removeFromCart(i)">
                  <mat-icon>remove_shopping_cart</mat-icon>
                </button>
              </mat-card-content>
            </mat-card>
          </div>
          <div>
            <p>Total: {{ totalCartAmount | currency }}</p>
            <button mat-raised-button color="primary" (click)="addCartToBudget()" [disabled]="cart.length === 0">Agregar al Presupuesto</button>
          </div>
        </section>
  
        <section>
          <h2>Presupuesto</h2>
          <div *ngFor="let item of budgetItems; let i = index">
            <mat-card class="budget-item">
              <mat-card-content>
                <p>{{ item.name }} - {{ item.category }} - {{ item.amount | currency }}</p>
                <button mat-icon-button color="warn" (click)="removeBudgetItem(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-card-content>
            </mat-card>
          </div>
        </section>
      </mat-card-content>
    </mat-card>
  </div>
  